import React, { useEffect } from "react";
import "./css/App.css";
import { Route, Switch, BrowserRouter as Router, useLocation } from "react-router-dom";
// import onWebviewClose from './components/Button';
// import Notice from "./Notice";
import NotFound from "./components/NotFound";
import NoticeList from "./Notice/NoticeList";
import NoticeArticle from "./Notice/NoticeArticle";

const ThemeWatcher = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const mode = params.get("mode");
    const isLight = mode && mode.toLowerCase() === "light";
    document.body.dataset.theme = isLight ? "light" : "dark";
  }, [search]);
  return null;
};


const App = () => {
  return (
    <Router>
      <React.Fragment>
        <ThemeWatcher />
        <Switch>
          <Route exact={true} path={"/"} component={NoticeList} />
          <Route path={"/notices/:id"} component={NoticeArticle} />
          <Route path="*" component={NotFound} />
        </Switch>
      </React.Fragment>
    </Router>
  );
};

export default App;
